(function($) {
  var $body = $('body');
  var BOOKING = {
    panelSelector: '.booking-panel',
    toggleSelector: '.booking-panel-toggle',
    showClass: 'booking-panel-show'
  }

  var PANEL = {
    show: function() {
      $body.addClass(BOOKING.showClass);

      $(document).on('click.bookingPanel', event => {
        if (
          !$(event.target).closest('.booking-panel').length &&
          !$(event.target).closest('.datepickers-container').length &&
          !$(event.target).closest('.datepicker--nav-action').length &&
          !$(event.target).closest('.datepicker--nav-title').length &&
          !$(event.target).is('.datepicker--cell')
        ) {
          PANEL.hide();
        }
      });
    },
    hide: function() {
      $body.removeClass(BOOKING.showClass);
      $(document).off('click.bookingPanel');
    },
    isShow: function() {
      return $body.hasClass(BOOKING.showClass);
    },
    isHide: function() {
      return !this.isShow();
    }
  }

  $(BOOKING.toggleSelector).on('click', event => {
    event.preventDefault();

    if (!$body.hasClass(BOOKING.showClass)) {
      PANEL.show();
    } else {
      PANEL.hide();
    }
  });

  $('.dropdown').on('show.bs.dropdown', () => {
    if (PANEL.isShow()) {
      PANEL.hide();
    }
  });

  $('.collapse').on('show.bs.collapse', () => {
    if (PANEL.isShow()) {
      PANEL.hide();
    }
  });

  $('.site-header').on('mini', () => {
    $(BOOKING.panelSelector).addClass('booking-panel--mini');
  });
  
  $('.site-header').on('full', () => {
    $(BOOKING.panelSelector).removeClass('booking-panel--mini');
  });
})(jQuery);